<template>
  <div>
    <NoSSR>
      <div class="login-popup" v-if="isNewUser && !menuOpen">
        <button class="close-btn" @click="close">
          <i class="icon-close"></i>
        </button>
        <div class="login-popup__text">
          <p
            class="title mb-1 -upper"
            v-html="$t('Zenith watches now come with <b>5 year warranty</b>')"
          ></p>
          <p class="text">
            <i>{{
              $t('Register your watch to get the extra 3 year warranty')
            }}</i>
          </p>
        </div>
        <button
          @click="anchorClick"
          class="btn"
          v-text="$t('SIGN-UP NOW')"
        ></button>
      </div>
    </NoSSR>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import NoSSR from 'src/themes/zenith/node_modules/vue-no-ssr'
import Vue from 'vue'
import { isServer } from '@vue-storefront/core/helpers'
const HIDE_AFTER_TOT_DAYS = 1
const SEC_PER_DAY = 1000 * 60 * 60 * 24

export default {
  name: 'LoginTooltip',
  props: ['menuOpen'],
  components: {
    NoSSR
  },
  data() {
    return {
      isNewUser: false
    }
  },
  created() {
    if (!isServer) {
      const lastViewed = Vue.prototype.$cookies.get(`Zmlyc3RfdmlzaXQ=`)
      if (lastViewed) {
        this.isNewUser =
          Date.now() < Number(lastViewed) + HIDE_AFTER_TOT_DAYS * SEC_PER_DAY
      } else {
        Vue.prototype.$cookies.set(`Zmlyc3RfdmlzaXQ=`, Date.now())
        this.isNewUser = true
      }
    }
  },
  methods: {
    close() {
      this.isNewUser = false
      Vue.prototype.$cookies.set(`Zmlyc3RfdmlzaXQ=2`, 1)
      Vue.prototype.$cookies.set(`Zmlyc3RfdmlzaXQ=`, 1)
    },
    anchorClick() {
      this.close()
      this.$router.push(this.localizedRoute('/login'))
    }
  },
  computed: {
    localizedUrl() {
      return currentStoreView().url || ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
.login-popup {
  position: fixed;
  border: 0.1rem solid var(--zenith-grey-medium);
  border-radius: 0.5rem;
  right: 1rem;
  padding: 1rem 1rem 1rem 5.5rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  flex-wrap: wrap;
  gap: 1rem;
  top: calc(var(--zenith-header-height, 9rem) - 1rem);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(1.75rem);
  max-width: 40rem;
  width: 70%;

  @include bp(lg) {
    padding: 1.5rem 1.5rem 1.5rem 4.5rem;
    gap: 2rem;
    right: 2rem;
    flex-direction: row;
    align-items: center;
  }

  .login-popup__text {
    flex: 1;
  }

  .btn {
    border-radius: 0.4rem;
    padding: 1rem 1.5rem;
    font-size: 1.2rem;
    font-weight: 500;
    flex-shrink: 0;
    min-height: unset;
  }

  .text {
    font-size: 1rem;
    line-height: 1.3rem;
  }

  .title {
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 120%;
  }
  .close-btn {
    position: absolute;
    top: 1rem;
    left: 1rem;
    border: none;
    background: none;
    padding: 0;
    filter: none !important;
  }
}
</style>
